import {
  type WorkerPendingVisitInvitesResponse,
  workerPendingVisitInvitesResponseSchema,
} from "@clipboard-health/contract-home-health-api";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";

export const VISIT_INVITES_API_URL = `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/visits/invites`;

export const getVisitInvitesQueryKey = [VISIT_INVITES_API_URL] as const;

interface UseWorkerPendingVisitInvitesParams {
  options?: UseGetQueryOptions<WorkerPendingVisitInvitesResponse>;
}

export function useWorkerPendingVisitInvites(
  params: UseWorkerPendingVisitInvitesParams = {}
): UseQueryResult<WorkerPendingVisitInvitesResponse> {
  const { options } = params;
  return useGetQuery({
    url: VISIT_INVITES_API_URL,
    responseSchema: workerPendingVisitInvitesResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_PENDING_VISIT_INVITES_FAILURE,
    },
    ...options,
  });
}
